export default __webpack_public_path__ + "static/icon-selection-4566e4f45d3c246c80dd45dbbca7363a.svg";